/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */

import {useState, useEffect} from 'react'
import {createPortal} from 'react-dom'
import {Modal} from 'react-bootstrap'
import {KTSVG} from '../../../../../_metronic/helpers'
import {useToast} from '../../../components/Toats'
import {LoadingSpan} from '../../../components/Loadings/loadingSpan'
import {useFormik} from 'formik'
import * as Yup from 'yup'
import {StepModal} from './components/stepModal'
import {
  getUnitConsumerOne,
  postUnitConsumerAll,
  updateUnitConsumerAll,
} from '../../../../services/unitConsumerService'
import styles from './modalUnitConsumer.module.css'

type DataForm = {
  name: string | null
  contrato: string | null
  cpf_cnpj: string | null
  username: string | null
  password: string | null
  state: string | null
  idPlant: string | null
  idConcessionarie: string | null
  energia_faturada_padrao: number | null
  energia_registrada_padrao: number | null
  leitura_anterior_padrao: number | null
  leitura_atual_padrao: number | null
  tarifa_padrao: number | null
  valor_faturado_padrao: number | null
  dia_padrão: number | null
  idUnitBranch?: string | null
}

type Props = {
  id?: string
  data?: DataForm
  show: boolean
  handleClose: () => void
}

const validationSchema = Yup.object().shape({
  name: Yup.string().required('Informe um nome para unidade consumidora'),
  contrato: Yup.string().required('Informe o número do contrato.'),
  username: Yup.string().required('Informe o username.'),
  password: Yup.string().required('Informe a senha.'),
  cpf_cnpj: Yup.string().required('Informe um CPF/CNPJ.'),
  state: Yup.string(),

  energia_faturada_padrao: Yup.number(),
  energia_registrada_padrao: Yup.number(),
  leitura_anterior_padrao: Yup.number(),
  leitura_atual_padrao: Yup.number(),
  tarifa_padrao: Yup.number(),
  valor_faturado_padrao: Yup.number(),
  dia_padrão: Yup.number(),

  saldo_economizado_anterior: Yup.number(),
  idUnitBranch: Yup.string(),
  idPlant: Yup.string().required('Informe qual usina a unidade está vinculada'),
  idConcessionarie: Yup.string().required('Informe qual concessionária a unidade está vinculada'),
  codeEmail: Yup.string(),
})

const modalsRoot = document.getElementById('root-modals') || document.body

const ModalAddUpdateUnitConsumer = ({show, handleClose, data, id}: Props) => {
  const {toggleToast} = useToast()

  const [initialValues, setInitialValues] = useState<any>({
    name: null,
    contrato: null,
    cpf_cnpj: null,
    username: null,
    password: null,
    state: null,
    idPlant: null,
    idConcessionarie: null,
    idUnitBranch: null,
    provided_email_concessionarie: false,

    saldo_economizado_anterior: null,

    energia_faturada_padrao: null,
    energia_registrada_padrao: null,
    leitura_anterior_padrao: null,
    leitura_atual_padrao: null,
    tarifa_padrao: null,
    valor_faturado_padrao: null,
    dia_padrão: null,
    codeEmail: null,
  })
  const [hasError, setHasError] = useState(false)
  const [loading, setLoading] = useState(false)

  const [emailsRedirect, setEmailsRedirect] = useState<any[]>([])

  const checkInputs = (): boolean => {
    if (
      !formik.values.name ||
      !formik.values.contrato ||
      !formik.values.idPlant ||
      !formik.values.idConcessionarie
    ) {
      return false
    }
    return true
  }

  const updateData = (fieldsToUpdate: any) => {
    const updatedData = {...initialValues, ...fieldsToUpdate}
    setInitialValues(updatedData)
  }

  const closed = () => {
    setHasError(false)
    formik.setValues(initialValues)
    handleClose()
  }

  const getMyUnitConsumerOne = async () => {
    try {
      setLoading(true)
      const myData = await getUnitConsumerOne(id ? id : '')

      const myObject = {
        contrato: myData.contrato ? myData.contrato : null,
        cpf_cnpj: myData.cpf_cnpj ? myData.cpf_cnpj : null,
        name: myData.name ? myData.name : null,
        username: myData.username ? myData.username : null,
        password: myData.password ? myData.password : null,
        state: myData.state ? myData.state : null,
        idPlant: myData.plant ? myData.plant.id : null,
        idConcessionarie:
          myData.concessioraire && myData.concessioraire.id ? myData.concessioraire.id : null,
        energia_faturada_padrao: myData.energia_faturada_padrao,
        energia_registrada_padrao: myData.energia_registrada_padrao,
        leitura_anterior_padrao: myData.leitura_anterior_padrao,
        leitura_atual_padrao: myData.leitura_atual_padrao,
        tarifa_padrao: myData.tarifa_padrao,
        valor_faturado_padrao: myData.valor_faturado_padrao,
        provided_email_concessionarie: myData.provided_email_concessionarie,
        dia_padrão: myData.dia_padrão,
        codeEmail: myData.codeEmail ? myData.codeEmail : null,
        saldo_economizado_anterior: myData.saldo_economizado_anterior
          ? myData.saldo_economizado_anterior
          : null,
      }
      formik.setValues(myObject)
      setEmailsRedirect(myData && myData.emailsRedirectUC ? myData.emailsRedirectUC : [])
    } catch (error) {
      toggleToast('Erro ao buscar a unidade consumidora. ', 'error')
    } finally {
      setLoading(false)
    }
  }

  const postUnitConsumerSubmit = async () => {
    try {
      setLoading(true)
      const myData = {
        name: formik.values.name,
        contrato: formik.values.contrato,
        cpf_cnpj: formik.values.cpf_cnpj,
        username: formik.values.username,
        password: formik.values.password,
        state: formik.values.state,
        idConcessionarie: formik.values.idConcessionarie,
        idPlant: formik.values.idPlant,
        type_unit_consumer: 'CONSUMIDORA',

        energia_faturada_padrao: formik.values.energia_faturada_padrao,
        energia_registrada_padrao: formik.values.energia_registrada_padrao,
        leitura_anterior_padrao: formik.values.leitura_anterior_padrao,
        leitura_atual_padrao: formik.values.leitura_atual_padrao,
        tarifa_padrao: formik.values.tarifa_padrao,
        valor_faturado_padrao: formik.values.valor_faturado_padrao,
        dia_padrão: formik.values.dia_padrão,
        saldo_economizado_anterior: formik.values.saldo_economizado_anterior,
      }
      Object.keys(myData).forEach((prop) => {
        if (myData[prop] === null) {
          delete myData[prop]
        }
      })

      await postUnitConsumerAll(myData)
      toggleToast('Sucesso ao cadastrar a unidade consumidora. ', 'success')
      closed()
    } catch (error: any) {
      toggleToast(
        error && error.response && error.response.data && error.response.data.message
          ? error.response.data.message
          : 'Erro ao cadastrar o unidade consumidora.',
        'error'
      )
    } finally {
      setLoading(false)
    }
  }

  const updateUnitConsumerSubmit = async (id: string) => {
    try {
      setLoading(true)
      const myData = {
        name: formik.values.name,
        contrato: formik.values.contrato,
        cpf_cnpj: formik.values.cpf_cnpj,
        username: formik.values.username,
        password: formik.values.password,
        state: formik.values.state,
        idConcessionarie: formik.values.idConcessionarie,
        provided_email_concessionarie: formik.values.provided_email_concessionarie,
        idPlant: formik.values.idPlant,

        energia_faturada_padrao: formik.values.energia_faturada_padrao,
        energia_registrada_padrao: formik.values.energia_registrada_padrao,
        leitura_anterior_padrao: formik.values.leitura_anterior_padrao,
        leitura_atual_padrao: formik.values.leitura_atual_padrao,
        tarifa_padrao: formik.values.tarifa_padrao,
        valor_faturado_padrao: formik.values.valor_faturado_padrao,
        dia_padrão: formik.values.dia_padrão,
        saldo_economizado_anterior: formik.values.saldo_economizado_anterior,
      }
      Object.keys(myData).forEach((prop) => {
        if (myData[prop] === null) {
          delete myData[prop]
        }
      })
      await updateUnitConsumerAll(myData, id)
      toggleToast('Sucesso ao atualizar a unidade consumidora. ', 'success')
      closed()
    } catch (error: any) {
      toggleToast(
        error && error.response && error.response.data && error.response.data.message
          ? error.response.data.message
          : 'Erro ao atualizar a unidade consumidora.',
        'error'
      )
    } finally {
      setLoading(false)
    }
  }

  const submit = () => {
    if (id) {
      updateUnitConsumerSubmit(id)
    } else {
      postUnitConsumerSubmit()
    }
  }

  const nextStep = () => {
    setHasError(false)
    if (!checkInputs()) {
      setHasError(true)
      return
    }
    submit()
  }

  const formik = useFormik({
    initialValues,
    validationSchema,
    validateOnChange: false,
    onSubmit: nextStep,
  })

  const refresh = () => {
    getMyUnitConsumerOne()
  }

  useEffect(() => {
    if (id) {
      getMyUnitConsumerOne()
    } else {
      formik.setValues(initialValues)
    }
  }, [show])

  const missingFields = [
    !formik.values.name && 'Nome',
    !formik.values.contrato && 'Nº do contrato',
    !formik.values.idConcessionarie && 'Concessionária',
    !formik.values.idPlant && 'Usina',
  ].filter(Boolean)

  return createPortal(
    <Modal
      id='kt_modal_create_app'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-dialog modal-dialog-centered modal-dialog-scrollable mw-1000px'
      show={show}
      onHide={closed}
      backdrop={true}
    >
      <div className='modal-header py-5'>
        <div className={styles.header}>
          <span className={styles.headerIcon}>
            <KTSVG
              path='/media/icons/duotune/general/gen001.svg'
              className='svg-icon-1 svg-icon-primary'
            />
          </span>
          <div>
            <h3 className={styles.headerTitle}>
              {id ? 'Editar unidade consumidora' : 'Nova unidade consumidora'}
            </h3>
            <span className={styles.headerSubtitle}>
              {id
                ? formik.values.name || 'Atualize os dados, o vínculo e a automação da unidade'
                : 'Preencha os dados, vincule a uma usina e configure a automação das faturas'}
            </span>
          </div>
        </div>

        <button
          type='button'
          className='btn btn-sm btn-icon btn-active-color-primary'
          onClick={closed}
          aria-label='Fechar'
        >
          <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg' />
        </button>
      </div>

      <div className={`modal-body ${styles.body}`}>
        <StepModal
          data={initialValues}
          dataEmails={emailsRedirect}
          hasError={hasError}
          formik={formik}
          id={id ? id : ''}
          show={show}
          refresh={refresh}
          codeEmail={formik.values.codeEmail ? formik.values.codeEmail : null}
        />
      </div>

      <div className={`modal-footer ${styles.footer}`}>
        {hasError && missingFields.length > 0 ? (
          <span className={styles.footerError}>
            <KTSVG
              path='/media/icons/duotune/general/gen044.svg'
              className='svg-icon-3 svg-icon-danger'
            />
            Preencha os campos obrigatórios: {missingFields.join(', ')}
          </span>
        ) : (
          <span className={styles.footerHint}>
            Campos com <span className='text-danger'>*</span> são obrigatórios
          </span>
        )}

        <div className={styles.footerActions}>
          <button type='button' className='btn btn-light' onClick={closed} disabled={loading}>
            Cancelar
          </button>
          <button type='button' className='btn btn-primary' disabled={loading} onClick={nextStep}>
            {loading ? (
              <>
                Salvando <LoadingSpan style={{marginLeft: '0.5rem'}} />
              </>
            ) : (
              <>
                <KTSVG path='/media/icons/duotune/arrows/arr085.svg' className='svg-icon-3 me-1' />
                {id ? 'Salvar alterações' : 'Cadastrar unidade'}
              </>
            )}
          </button>
        </div>
      </div>
    </Modal>,
    modalsRoot
  )
}

export {ModalAddUpdateUnitConsumer}
